import { useCallback } from 'react';
import { useCancelEmissorOrderMutation, } from '../services/contractOrdersApi';
export function useEmissorCancelOrder() {
    const [trigger, state] = useCancelEmissorOrderMutation();
    const cancelOrder = useCallback((input) => trigger(input).unwrap(), [trigger]);
    return { cancelOrder, isLoading: state.isLoading, isError: state.isError };
}
